import { useState, useEffect, useRef } from "react";
import { Typography, Box, InputBase, Tooltip, IconButton } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseConsultation } from "./UseConsultation";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import StateCom from "./StateCom";
import CheckIcon from "@mui/icons-material/Check";
import { Circle } from "@mui/icons-material";

export default function Consultation(props) {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetConsultants } = UseConsultation();
  const [consultantRes, setConsultantRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [orderState, setOrderState] = useState(
    searchParams && searchParams.get("state") ? searchParams.get("state") : null
  );

  const [refreshPage, setRefreshPage] = useState(false);
  const [backID, setBackID] = useState("");

  useEffect(() => {
    if (location.state && location.state.orderState) {
      setOrderState(location.state.orderState);
    }
  }, [location.state]);

  useEffect(() => {
    window.history.replaceState({}, document.title);
    if (location && location.hash) {
      setSearch(location.hash.replace("#", ""));

      setRefreshPage(true);
    }
    if (
      !searchParams ||
      !searchParams.get("state") ||
      searchParams.get("state") == null
    ) {
      return navigate(`/consulate?state=null`);
    }
  }, [searchParams]);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetConsultants(
      myPc,
      search,
      searchParams ? searchParams.get("state") : 1,
      (consultant) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(consultant.pageCondition.totalPage);
          return;
        }
        setConsultantRes(consultant);
      },
      true
    );
  }, [myPc, orderState, searchParams]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
      setBackID(location.state.id);
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {backID && cellValues.row.id == backID && (
              <Circle fontSize="small" sx={{ fill: "purple", mr: 0.5 }} />
            )}

            <Typography variant="span" sx={{ whiteSpace: "normal" }}>
              {cellValues.row.rowNO}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "firstName",
      headerName: "نام",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "stateTitle",
      headerName: "وضعیت",
      width: 100,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "عملیات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="detail">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setScrollTo(cellValues.api.getScrollPosition());

                return navigate("/consulate/consultationDetails", {
                  state: {
                    model: cellValues.row,
                    myPc: myPc,
                    search: search,
                    id: cellValues.row.id,
                    userID: cellValues.row.userID,
                    orderState: searchParams.get("state"),
                  },
                });
              }}
            >
              <AssignmentIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 210,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/consulate" }],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          height: "100%",
        }}
      >
        <Box sx={{ display: "flex", width: "100%" }}>
          <StateCom
            // stateCounts={stateCounts}
            orderState={orderState}
            setOrderState={setOrderState}
            setRefreshPage={setRefreshPage}
            setSearch={setSearch}
          ></StateCom>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {consultantRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={consultantRes.pageCondition.pageCount}
              rows={consultantRes.items ? consultantRes.items : []}
              paginationMode="server"
              page={consultantRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={consultantRes.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  nofab: true,
                  rowCount: consultantRes.pageCondition.totalItemCount,
                },
              }}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .Green": {
                  backgroundColor: "#56ff004f !important",
                },
                "& .red": {
                  backgroundColor: "#ff9c9c !important",
                },
                "& .pink": {
                  backgroundColor: "#ffdbdb !important",
                },
                "& .orange": {
                  backgroundColor: "#FFC36E !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.state == 1) {
                  return "Green";
                }
                if (params.row.state == 2) {
                  return "red";
                }
                if (params.row.state == 3) {
                  return "orange";
                }
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
    </Detail>
  );
}
